
























































/* General */
import Vue from 'vue'
import moment from 'moment'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import MailboxSettingsOfficeHoursDay from './components/mailbox-settings-office-hours-day.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import {
  IMailboxesOutputOfficeHours,
  IOfficeHourDay,
} from '@/api/types/response.types'
import { IMailboxesInputOfficeHours } from '@/api/types/request.types'

export default Vue.extend({
  name: 'MailboxSettingsAutoResponder',

  metaInfo(): any {
    return {
      title: `Office Hours - ${this.officeHoursInfo.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    MailboxSettingsOfficeHoursDay,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      RouteAssistant,
      isLoading: true,
      isSubmitting: false,
      expandForm: false,
      officeHoursInfo: {
        name: '',
      } as IMailboxesOutputOfficeHours,
      pickerFormat: 'hh:mm A',
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    formRules(): any {
      const rules = {} as any

      this.officeHoursInfo.listDays.forEach(
        (element: IOfficeHourDay, idx: number) => {
          rules[`listDays[${idx}].openTime`] = [
            { validator: this.validateHours, trigger: 'submit' },
          ]
        },
      )
      return rules
    },
  },

  async created() {
    this.isLoading = true
    await this.getOfficeHoursInfo()
    this.isLoading = false
  },

  methods: {
    async getOfficeHoursInfo() {
      try {
        this.officeHoursInfo = await MailboxesAPI.get_OfficeHours(this.id)
        this.expandForm = this.officeHoursInfo.hasSet
      } catch (error) {
        this.$error.emit(error)
      }
    },

    validateHours(rule: any, value: any, callback: any) {
      const fieldIndex = parseInt(
        rule.field.split(/\[[^\d]*(\d+)[^\d]*\]/)[1],
        0,
      )
      if (this.officeHoursInfo.listDays[fieldIndex].isOpen) {
        const openTime = moment(
          this.officeHoursInfo.listDays[fieldIndex].openTime,
          'hh:mm A',
        )
        const closeTime = moment(
          this.officeHoursInfo.listDays[fieldIndex].closeTime,
          'hh:mm A',
        )
        const valid = openTime.isBefore(closeTime)
        if (!valid) {
          const message = 'Open time must be before close time'
          return callback(new Error(message))
        }
      }

      return callback()
    },

    async updateOfficeHours() {
      // @ts-ignore
      await this.$refs.timeZoneForm.validate(async (valid: boolean) => {
        if (valid) {
          try {
            this.isSubmitting = true
            const formData = {
              timeZoneID: this.officeHoursInfo.timeZoneID,
              listDays: this.officeHoursInfo.listDays,
            } as IMailboxesInputOfficeHours
            const response = await MailboxesAPI.post_OfficeHours(
              this.id,
              formData,
            )
            this.$messaging.showSuccess(response.message)
          } catch (error) {
            this.$error.emit(error, true)
          } finally {
            this.isSubmitting = false
          }
        } else {
          return false
        }
      })
    },
  },
})
